import { Component, OnInit } from '@angular/core';
import { TransferService } from '../../services/transfer.service';
import { ViewChild, ElementRef, ViewContainerRef } from '@angular/core';
import { ShopService } from '../../../configuration/services/shop.service';
import * as _ from 'lodash/lodash';


@Component({
  selector: 'app-list-transfer',
  templateUrl: './list-transfer.component.html',
  styleUrls: ['./list-transfer.component.css'],
  providers:[TransferService,ShopService]
})
export class ListTransferComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  transfers:any = [];
  filters:any = {
    finished:{contains: ""},
  };
  role:number = 3;
  shops: any = [];

  constructor(private transferService: TransferService,
              private shopService:ShopService, vcr: ViewContainerRef) { 
              }

  ngOnInit() {
    this.getTransfers();
    this.getShops();
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;
    }catch(e){
    }
  }

  getShops(){
    this.shopService.query({})
      .subscribe((shops) => {
          this.shops = shops;
          this.shops.unshift({name:"Todas", id:-1})
      });
  }


  getTransfers(){
    var params = {
      where: _.cloneDeep(this.filters),
      sort: 'id DESC',
      skip: (this.p-1)*10,
      limit: 10
    };
    this.transferService.query(params)
      .subscribe((transfers) => {
      let countParams = {
        where: _.cloneDeep(params.where),
      };
      this.transferService.count(countParams)
      .subscribe((count) => {
        this.totalItems = count.count;
      });
      this.transfers = transfers;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/transfer/components/list-transfer/list-transfer.component.ts